// extracted by mini-css-extract-plugin
module.exports = {"detailsCard":"DockSchedulerAppointmentDetails_detailsCard__1pVbh","errorModalPrompt":"DockSchedulerAppointmentDetails_errorModalPrompt__8VFby"};